<div class="vcu-explorer">
  <!-- ═══ Toolbar estilo Vision: navegação + endereço + config + busca ═══ -->
  <div class="explorer-toolbar">
    <div class="explorer-nav">
      <button type="button" class="explorer-tool-btn" (click)="goHome()"
        [pTooltip]="'vcuFileExplorer.navHome' | transloco" tooltipPosition="bottom">
        <i class="pi pi-home"></i>
      </button>
      <button type="button" class="explorer-tool-btn" (click)="goBack()" [disabled]="!canGoBack"
        [pTooltip]="'vcuFileExplorer.navBack' | transloco" tooltipPosition="bottom">
        <i class="pi pi-arrow-left"></i>
      </button>
      <button type="button" class="explorer-tool-btn" (click)="goForward()" [disabled]="!canGoForward"
        [pTooltip]="'vcuFileExplorer.navForward' | transloco" tooltipPosition="bottom">
        <i class="pi pi-arrow-right"></i>
      </button>
      <button type="button" class="explorer-tool-btn" (click)="goUp()" [disabled]="!canGoUp"
        [pTooltip]="'vcuFileExplorer.navUp' | transloco" tooltipPosition="bottom">
        <i class="pi pi-arrow-up"></i>
      </button>
      <button type="button" class="explorer-tool-btn" disabled
        [pTooltip]="'vcuFileExplorer.navNewFolder' | transloco" tooltipPosition="bottom">
        <i class="pi pi-folder-plus"></i>
      </button>
      <button type="button" class="explorer-tool-btn" (click)="refresh()"
        [disabled]="refreshing"
        [pTooltip]="'vcuFileExplorer.navRefresh' | transloco" tooltipPosition="bottom">
        <i [class]="refreshing ? 'pi pi-spin pi-spinner' : 'pi pi-refresh'"></i>
      </button>
    </div>

    <div class="explorer-address">
      <i class="pi pi-folder-open"></i>
      <span class="explorer-address-path">{{ addressPath }}</span>
    </div>

    <button type="button" class="explorer-tool-btn explorer-gear"
      [pTooltip]="'vcuFileExplorer.settings' | transloco" tooltipPosition="bottom">
      <i class="pi pi-cog"></i>
    </button>

    <p-iconField iconPosition="right" class="explorer-filter ftds-chamfer-bordered">
      <p-inputIcon><i class="pi pi-search"></i></p-inputIcon>
      <input pInputText type="text" [placeholder]="'vcuFileExplorer.searchPlaceholder' | transloco"
        class="explorer-filter-input" [(ngModel)]="filterText" />
    </p-iconField>
  </div>

  <!-- ═══ Barra de seleção: assume as ações enquanto houver algo marcado ═══ -->
  <div class="sel-bar" *ngIf="hasSelection">
    <i class="pi pi-check-circle sel-bar__icon"></i>
    <span class="sel-bar__count">
      {{ (selectedPaths.size === 1
            ? 'vcuFileExplorer.selectionCountOne'
            : 'vcuFileExplorer.selectionCount') | transloco: { count: selectedPaths.size } }}
    </span>
    <span class="sel-bar__spacer"></span>

    <!-- Com um só marcado cabe o conjunto completo; com vários, só o que faz sentido em lote. -->
    <ng-container *ngIf="singleSelectedNode as sel; else selectionBulk">
      <button type="button" class="sel-bar__btn" *ngIf="!readOnly" (click)="emitViewChannels(sel)">
        <i [class]="sel.typeLabel === 'log' ? 'pi pi-chart-line' : 'pi pi-th-large'"></i>
        {{ (sel.typeLabel === 'log' ? 'vcuFileExplorer.tooltipViewChannels' : 'vcuFileExplorer.tooltipViewMap') | transloco }}
      </button>
      <button type="button" class="sel-bar__btn" (click)="emitDownload(sel, 0)">
        <i class="pi pi-download"></i>
        {{ 'vcuFileExplorer.download' | transloco }}
      </button>
      <button type="button" class="sel-bar__btn" *ngIf="!readOnly" (click)="emitShare(sel)">
        <i class="pi pi-share-alt"></i>
        {{ 'vcuFileExplorer.tooltipShare' | transloco }}
      </button>
      <button type="button" class="sel-bar__btn" *ngIf="!readOnly" (click)="emitLinkVcu(sel)">
        <i class="pi pi-link"></i>
        {{ 'vcuFileExplorer.tooltipLinkVcu' | transloco }}
      </button>
      <button type="button" class="sel-bar__btn" *ngIf="!readOnly" (click)="emitRename(sel)">
        <i class="pi pi-pencil"></i>
        {{ 'vcuFileExplorer.tooltipRename' | transloco }}
      </button>
      <button type="button" class="sel-bar__btn" *ngIf="!readOnly" (click)="emitMoveOne(sel)">
        <i class="pi pi-folder-open"></i>
        {{ 'vcuFileExplorer.tooltipMove' | transloco }}
      </button>
      <button type="button" class="sel-bar__btn sel-bar__btn--danger" *ngIf="!readOnly"
              [disabled]="sel.file && deletingIds.has(sel.file.id)" (click)="emitDelete(sel, 0)">
        <i [class]="sel.file && deletingIds.has(sel.file.id) ? 'pi pi-spin pi-spinner' : 'pi pi-trash'"></i>
        {{ 'vcuFileExplorer.tooltipDelete' | transloco }}
      </button>
    </ng-container>

    <ng-template #selectionBulk>
      <button type="button" class="sel-bar__btn" (click)="emitDownloadSelected()">
        <i class="pi pi-download"></i>
        {{ 'vcuFileExplorer.download' | transloco }}
      </button>
      <button type="button" class="sel-bar__btn" *ngIf="!readOnly" (click)="emitMoveSelected()">
        <i class="pi pi-folder-open"></i>
        {{ 'vcuFileExplorer.tooltipMove' | transloco }}
      </button>
      <button type="button" class="sel-bar__btn sel-bar__btn--danger" *ngIf="!readOnly" (click)="emitDeleteSelected()">
        <i class="pi pi-trash"></i>
        {{ 'vcuFileExplorer.tooltipDelete' | transloco }}
      </button>
    </ng-template>

    <button type="button" class="sel-bar__clear" (click)="clearSelection()"
            [attr.aria-label]="'vcuFileExplorer.clearSelection' | transloco"
            [pTooltip]="'vcuFileExplorer.clearSelection' | transloco" tooltipPosition="bottom">
      <i class="pi pi-times"></i>
    </button>
  </div>

  <!-- ═══ Corpo: tabela (esq) + painel de detalhes (dir) ═══ -->
  <div class="explorer-body">
    <div class="explorer-main">
      <div class="explorer-section-head">{{ currentFolderName }}</div>

      <div class="explorer-table-wrapper">
        <p-table
          [value]="filteredChildren"
          dataKey="fullPath"
          [tableStyle]="{ 'width': '100%' }"
          styleClass="p-datatable-sm explorer-table"
        >
          <ng-template pTemplate="header">
            <tr>
              <th *ngIf="hasFileInCurrentView" class="col-check">
                <p-checkbox [binary]="true" [ngModel]="allFilesSelected" (ngModelChange)="toggleSelectAll()" inputId="selectAll" />
              </th>
              <th class="col-name" pSortableColumn="name">
                {{ 'vcuFileExplorer.colName' | transloco }} <p-sortIcon field="name" />
              </th>
              <th class="col-type">{{ 'vcuFileExplorer.colType' | transloco }}</th>
              <th class="col-duration">{{ 'vcuFileExplorer.colDuration' | transloco }}</th>
              <th class="col-modified" pSortableColumn="modifiedDate">
                {{ 'vcuFileExplorer.colModified' | transloco }} <p-sortIcon field="modifiedDate" />
              </th>
              <th class="col-created" pSortableColumn="createdDate">
                {{ 'vcuFileExplorer.colCreated' | transloco }} <p-sortIcon field="createdDate" />
              </th>
              <th *ngIf="showActionsColumn" class="col-actions">{{ 'vcuFileExplorer.colActions' | transloco }}</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-node let-ri="rowIndex">
            <tr
              [class.folder-row]="node.isFolder"
              [class.file-row]="!node.isFolder"
              [class.is-detail]="isDetail(node)"
              [class.is-checked]="isSelected(node)"
              (click)="selectNode(node)"
              (dblclick)="onRowClick(node)"
              (contextmenu)="openRowMenu(node, $event)"
            >
              <td *ngIf="hasFileInCurrentView" class="col-check" (click)="$event.stopPropagation()">
                <p-checkbox
                  [binary]="true"
                  [ngModel]="isSelected(node)"
                  (ngModelChange)="toggleRow(node)"
                  [inputId]="'chk-' + ri"
                  [disabled]="node.isFolder"
                />
              </td>
              <td class="col-name" [attr.colspan]="folderSpansActions(node) ? 6 : 1">
                <span class="name-cell">
                  <i [class]="node.isFolder ? 'pi pi-folder explorer-icon-folder' : (node.typeLabel === 'log' ? 'pi pi-chart-line explorer-icon-log' : 'pi pi-th-large explorer-icon-map')"></i>
                  <span class="item-name">{{ node.name }}</span>
                </span>
              </td>
              <ng-container *ngIf="!folderSpansActions(node)">
              <td class="col-type">{{ getTypeLabel(node) }}</td>
              <td class="col-duration">{{ getLogDuration(node) }}</td>
              <td class="col-modified">{{ getModifiedDate(node) }}</td>
              <td class="col-created">{{ getCreatedDate(node) }}</td>
              <td *ngIf="showActionsColumn" class="col-actions">
                <ng-container *ngIf="!node.isFolder && node.file">
                  <p-button
                    *ngIf="!readOnly"
                    [icon]="node.typeLabel === 'log' ? 'pi pi-chart-line' : 'pi pi-th-large'"
                    [rounded]="true"
                    [text]="true"
                    [pTooltip]="(node.typeLabel === 'log' ? 'vcuFileExplorer.tooltipViewChannels' : 'vcuFileExplorer.tooltipViewMap') | transloco"
                    (onClick)="emitViewChannels(node); $event.stopPropagation()"
                  />
                  <p-button
                    icon="pi pi-download"
                    [rounded]="true"
                    [text]="true"
                    [pTooltip]="'vcuFileExplorer.download' | transloco"
                    (onClick)="emitDownload(node, ri); $event.stopPropagation()"
                  />
                  <!-- Mesma lista do clique direito: um caminho para quem conhece o gesto,
                       outro para quem não conhece (e para o toque, que não tem botão direito). -->
                  <p-button
                    icon="pi pi-ellipsis-v"
                    [rounded]="true"
                    [text]="true"
                    [pTooltip]="'vcuFileExplorer.moreActions' | transloco"
                    (onClick)="openRowMenu(node, $event)"
                  />
                </ng-container>
              </td>
              </ng-container>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td [attr.colspan]="columnCount" class="empty-message">
                {{ 'vcuFileExplorer.emptyFolder' | transloco }}
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>

    <!-- ═══ Painel de Detalhes ═══ -->
    <aside class="explorer-details">
      <div class="explorer-section-head">{{ 'vcuFileExplorer.detailsTitle' | transloco }}</div>

      <!-- Multi-seleção (2+ checkboxes) -->
      <div class="details-card" *ngIf="isMulti">
        <div class="details-hero">
          <div class="details-icon"><i class="pi pi-clone"></i></div>
          <div class="details-name">
            {{ 'vcuFileExplorer.detailMultiTitle' | transloco: { count: selectedPaths.size } }}
          </div>
        </div>
      </div>

      <!-- Nada selecionado -->
      <div class="details-empty" *ngIf="!isMulti && !detailTarget">
        <i class="pi pi-info-circle"></i>
        <span>{{ 'vcuFileExplorer.detailEmpty' | transloco }}</span>
      </div>

      <!-- Arquivo único (1 selecionado ou clicado) -->
      <div class="details-card" *ngIf="!isMulti && detailTarget as dt">
        <ng-container *ngTemplateOutlet="fileInfo; context: { $implicit: dt }"></ng-container>
      </div>
    </aside>
  </div>
</div>

<!-- Conteúdo de detalhes reutilizável (painel lateral + modal de info) -->
<ng-template #fileInfo let-node>
  <div class="details-hero">
    <div class="details-icon">
      <i [class]="node.typeLabel === 'log' ? 'pi pi-chart-line' : 'pi pi-th-large'"></i>
    </div>
    <div class="details-name">{{ node.name }}</div>
    <div class="details-type">{{ getTypeLabel(node) }}</div>
  </div>

  <div class="details-rows">
    <div class="details-row">
      <span class="details-label">{{ 'vcuFileExplorer.detailAddress' | transloco }}</span>
      <span class="details-value details-value--path">{{ node.file?.pathFile || node.fullPath }}</span>
    </div>
    <div class="details-row">
      <span class="details-label">{{ 'vcuFileExplorer.colModified' | transloco }}</span>
      <span class="details-value ftds-mono">{{ getModifiedDate(node) }}</span>
    </div>
    <div class="details-row">
      <span class="details-label">{{ 'vcuFileExplorer.colCreated' | transloco }}</span>
      <span class="details-value ftds-mono">{{ getCreatedDate(node) }}</span>
    </div>
    <div class="details-row">
      <span class="details-label">{{ 'vcuFileExplorer.detailSize' | transloco }}</span>
      <span class="details-value">---</span>
    </div>
    <div class="details-row" *ngIf="node.typeLabel === 'log'">
      <span class="details-label">{{ 'vcuFileExplorer.colDuration' | transloco }}</span>
      <span class="details-value ftds-mono">{{ getLogDuration(node) }}</span>
    </div>
    <div class="details-row">
      <span class="details-label">{{ 'vcuFileExplorer.detailCar' | transloco }}</span>
      <span class="details-value">---</span>
    </div>
    <div class="details-row">
      <span class="details-label">{{ 'vcuFileExplorer.detailPilot' | transloco }}</span>
      <span class="details-value">---</span>
    </div>
    <div class="details-row">
      <span class="details-label">{{ 'vcuFileExplorer.detailChampionship' | transloco }}</span>
      <span class="details-value">---</span>
    </div>
  </div>
</ng-template>

<!-- Modal de info (botão "info" da linha) — útil sobretudo no mobile, onde o painel lateral some -->
<p-dialog
  [(visible)]="showInfo"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [dismissableMask]="true"
  [header]="'vcuFileExplorer.detailsTitle' | transloco"
  styleClass="explorer-info-dialog"
  [style]="{ width: 'min(420px, 92vw)' }"
>
  <div class="details-card details-card--flush" *ngIf="infoNode">
    <ng-container *ngTemplateOutlet="fileInfo; context: { $implicit: infoNode }"></ng-container>
  </div>
</p-dialog>

<!-- Menu de linha: aberto pelo "⋮" e pelo clique direito, com o mesmo conteúdo.
     appendTo="body" porque a tabela tem overflow e recortaria o popup. -->
<p-contextMenu #rowMenu [model]="rowMenuItems" appendTo="body" styleClass="explorer-row-menu"></p-contextMenu>
